// extracted by mini-css-extract-plugin
export var disabled = "_sd-0";